import { render, staticRenderFns } from "./PushGroup.vue?vue&type=template&id=a8bbd02c&"
import script from "./PushGroup.vue?vue&type=script&lang=ts&"
export * from "./PushGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports